import { render, staticRenderFns } from "./NewLandingPage.vue?vue&type=template&id=dbcc7744&"
import script from "./NewLandingPage.vue?vue&type=script&lang=js&"
export * from "./NewLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./NewLandingPage.vue?vue&type=style&index=0&id=dbcc7744&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports